export default __webpack_public_path__ + "static/media/DREGG.42db80f9.png";